import cities from "./cities.component";
import citiesUrls from "./cities.urls";
import CitiesTransforms from "./cities.transforms";

const citiesModule = angular
  .module("app.components.cities", [])
  .component("citiesPage", cities)
  .service("CitiesTransforms", CitiesTransforms)
  .config(citiesUrls);

export default citiesModule;



// WEBPACK FOOTER //
// ./src/pages/cities/cities.module.js